import styled from 'styled-components';

import BadgeComponent from '../../../../components/Badge';

export const Badge = styled(BadgeComponent)`
  padding: 5px 17px !important;
`;

export const HeaderContent = styled.div`
  min-height: 62px;
  min-width: 0;
  flex: 1 1 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 0;
`;

export const HeaderActions = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: 16px;
`;
